// import React, { useState } from 'react';
// import Grid from "@material-ui/core/Grid";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// import FormControl from "@material-ui/core/FormControl";
// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
// import { toast } from "react-toastify";
// import SimpleReactValidator from "simple-react-validator";
// import {
//     sendBrokerRegistration,
//     rateLimiter,
//     handleApiError,
//     getSuccessMessage
// } from '../../utils/api';

// const AgencyRegistrationForm = ({ onPrevious }) => {
//     const [step, setStep] = useState(1);
//     const [validator] = useState(new SimpleReactValidator({
//         className: 'error-message'
//     }));

//     const [formData, setFormData] = useState({
//         // Company Details
//         companyName: '',
//         email: '',
//         relationshipManager: '',
//         officeNumber: '',
//         website: '',
//         companyWhatsapp: '',
//         gmWhatsapp: '',
//         accountsContact: '',
//         operationalCountry: '',

//         // Address Details
//         address: '',
//         city: '',
//         state: '',
//         zipCode: '',
//         country: '',

//         // Document Details
//         tradeLicense: null,
//         rera: null,
//         taxRegistration: null,
//         passport: null,
//         otherDocuments: null
//     });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({
//             ...formData,
//             [name]: value
//         });
//         validator.showMessages();
//     };

//     const handleFileChange = (e) => {
//         const { name, files } = e.target;
//         setFormData({
//             ...formData,
//             [name]: files[0]
//         });
//     };

//     const handleNext = () => {
//         if (step === 1) {
//             if (validator.fieldValid('companyName') &&
//                 validator.fieldValid('email') &&
//                 validator.fieldValid('officeNumber') &&
//                 validator.fieldValid('companyWhatsapp') &&
//                 validator.fieldValid('gmWhatsapp') &&
//                 validator.fieldValid('accountsContact') &&
//                 validator.fieldValid('operationalCountry')) {
//                 setStep(2);
//             } else {
//                 validator.showMessages();
//                 toast.error('Please fill all required fields!');
//             }
//         } else if (step === 2) {
//             if (validator.fieldValid('address') &&
//                 validator.fieldValid('city') &&
//                 validator.fieldValid('country')) {
//                 setStep(3);
//             } else {
//                 validator.showMessages();
//                 toast.error('Please fill all required fields!');
//             }
//         }
//     };

//     const handlePrevious = () => {
//         if (step > 1) {
//             setStep(step - 1);
//         } else {
//             onPrevious();
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!validator.allValid()) {
//             validator.showMessages();
//             toast.error('Please fill all required fields!');
//             return;
//         }

//         // Check if required documents are uploaded
//         if (!formData.tradeLicense || !formData.rera || !formData.passport) {
//             toast.error('Please upload required documents (Trade License, RERA Certificate, and Passport)');
//             return;
//         }

//         // Check rate limiting
//         if (!rateLimiter.canMakeRequest('/api/send-broker-registration')) {
//             toast.error('Too many requests. Please wait a moment and try again.');
//             return;
//         }

//         try {
//             // Prepare form data for API with all details including files
//             const apiFormData = {
//                 name: formData.companyName,
//                 email: formData.email,
//                 phone: formData.officeNumber,
//                 registrationType: 'agency',
//                 company: formData.companyName,
//                 relationshipManager: formData.relationshipManager,
//                 officeNumber: formData.officeNumber,
//                 website: formData.website,
//                 companyWhatsapp: formData.companyWhatsapp,
//                 gmWhatsapp: formData.gmWhatsapp,
//                 accountsContact: formData.accountsContact,
//                 operationalCountry: formData.operationalCountry,
//                 address: formData.address,
//                 city: formData.city,
//                 state: formData.state,
//                 zipCode: formData.zipCode,
//                 country: formData.country,
//                 licenseNumber: formData.rera || 'Pending',
//                 experience: 'Agency Registration',
//                 message: `Website: ${formData.website || 'Not provided'}\nOperational Country: ${formData.operationalCountry}\nRelationship Manager: ${formData.relationshipManager || 'Not assigned'}`,

//                 // Document files
//                 tradeLicense: formData.tradeLicense,
//                 rera: formData.rera,
//                 taxRegistration: formData.taxRegistration,
//                 passport: formData.passport,
//                 otherDocuments: formData.otherDocuments
//             };

//             // Send broker registration via API
//             const response = await sendBrokerRegistration(apiFormData);

//             if (response.success) {
//                 toast.success(getSuccessMessage('broker'));

//                 // Reset form or redirect
//                 // You can add navigation logic here if needed
//             } else {
//                 throw new Error(response.message || 'Failed to submit registration');
//             }
//         } catch (error) {
//             const errorMessage = handleApiError(error, 'broker');
//             toast.error(errorMessage);
//         }
//     };

//     return (
//         <div className="agency-registration-form">
//             <div className="form-header">
//                 <h2>Agency Registration</h2>
//                 <p>Complete your agency profile to start accessing exclusive properties and client leads</p>
//             </div>

//             <form onSubmit={handleSubmit}>
//                 {step === 1 && (
//                     <div className="form-step">
//                         <div className="step-header">
//                             <div className="step-number">1</div>
//                             <h3>Company Information</h3>
//                         </div>

//                         <div className="form-container">
//                             <Grid container spacing={3}>
//                                 <Grid item xs={12}>
//                                     <div className="form-field">
//                                         <label className="required">Company Name</label>
//                                         <TextField
//                                             fullWidth
//                                             name="companyName"
//                                             value={formData.companyName}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             InputProps={{
//                                                 placeholder: "Enter your company name"
//                                             }}
//                                         />
//                                         {validator.message('companyName', formData.companyName, 'required')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">Email Address</label>
//                                         <TextField
//                                             fullWidth
//                                             name="email"
//                                             type="email"
//                                             value={formData.email}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             InputProps={{
//                                                 placeholder: "your.email@example.com"
//                                             }}
//                                         />
//                                         {validator.message('email', formData.email, 'required|email')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label>Relationship Manager</label>
//                                         <FormControl variant="outlined" fullWidth>
//                                             <Select
//                                                 name="relationshipManager"
//                                                 value={formData.relationshipManager}
//                                                 onChange={handleChange}
//                                                 displayEmpty
//                                             >
//                                                 <MenuItem value="">
//                                                     <em>--Select Relationship Manager--</em>
//                                                 </MenuItem>
//                                                 <MenuItem value="manager1">Nilum</MenuItem>
//                                                 <MenuItem value="manager2">Junaid</MenuItem>
//                                                 <MenuItem value="manager3">Jabbar Naveed</MenuItem>
//                                             </Select>
//                                         </FormControl>
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">Office Phone Number</label>
//                                         <TextField
//                                             fullWidth
//                                             name="officeNumber"
//                                             value={formData.officeNumber}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             InputProps={{
//                                                 placeholder: "+971 XX XXX XXXX"
//                                             }}
//                                         />
//                                         {validator.message('officeNumber', formData.officeNumber, 'required')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label>Website (Optional)</label>
//                                         <TextField
//                                             fullWidth
//                                             name="website"
//                                             value={formData.website}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             InputProps={{
//                                                 placeholder: "https://www.yourcompany.com"
//                                             }}
//                                         />
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">Company WhatsApp</label>
//                                         <TextField
//                                             fullWidth
//                                             name="companyWhatsapp"
//                                             value={formData.companyWhatsapp}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             InputProps={{
//                                                 placeholder: "+971 XX XXX XXXX"
//                                             }}
//                                         />
//                                         {validator.message('companyWhatsapp', formData.companyWhatsapp, 'required')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">General Manager WhatsApp</label>
//                                         <TextField
//                                             fullWidth
//                                             name="gmWhatsapp"
//                                             value={formData.gmWhatsapp}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             InputProps={{
//                                                 placeholder: "+971 XX XXX XXXX"
//                                             }}
//                                         />
//                                         {validator.message('gmWhatsapp', formData.gmWhatsapp, 'required')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">Accounts Contact Number</label>
//                                         <TextField
//                                             fullWidth
//                                             name="accountsContact"
//                                             value={formData.accountsContact}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             InputProps={{
//                                                 placeholder: "+971 XX XXX XXXX"
//                                             }}
//                                         />
//                                         {validator.message('accountsContact', formData.accountsContact, 'required')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">Operational Country</label>
//                                         <FormControl variant="outlined" fullWidth required>
//                                             <Select
//                                                 name="operationalCountry"
//                                                 value={formData.operationalCountry}
//                                                 onChange={handleChange}
//                                                 displayEmpty
//                                             >
//                                                 <MenuItem value="">
//                                                     <em>--Select Country--</em>
//                                                 </MenuItem>
//                                                 <MenuItem value="UAE">United Arab Emirates</MenuItem>
//                                                 <MenuItem value="Saudi Arabia">Saudi Arabia</MenuItem>
//                                                 <MenuItem value="Qatar">Qatar</MenuItem>
//                                                 <MenuItem value="Oman">Oman</MenuItem>
//                                                 <MenuItem value="Kuwait">Kuwait</MenuItem>
//                                                 <MenuItem value="Bahrain">Bahrain</MenuItem>
//                                             </Select>
//                                         </FormControl>
//                                         {validator.message('operationalCountry', formData.operationalCountry, 'required')}
//                                     </div>
//                                 </Grid>
//                             </Grid>
//                         </div>
//                     </div>
//                 )}

//                 {step === 2 && (
//                     <div className="form-step">
//                         <div className="step-header">
//                             <div className="step-number">2</div>
//                             <h3>Address Information</h3>
//                         </div>

//                         <div className="form-container">
//                             <Grid container spacing={3}>
//                                 <Grid item xs={12}>
//                                     <div className="form-field">
//                                         <label className="required">Complete Address</label>
//                                         <TextField
//                                             fullWidth
//                                             name="address"
//                                             value={formData.address}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             multiline
//                                             rows={3}
//                                             InputProps={{
//                                                 placeholder: "Enter your complete business address"
//                                             }}
//                                         />
//                                         {validator.message('address', formData.address, 'required')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">City</label>
//                                         <TextField
//                                             fullWidth
//                                             name="city"
//                                             value={formData.city}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             required
//                                             InputProps={{
//                                                 placeholder: "Enter city name"
//                                             }}
//                                         />
//                                         {validator.message('city', formData.city, 'required')}
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label>State/Province (Optional)</label>
//                                         <TextField
//                                             fullWidth
//                                             name="state"
//                                             value={formData.state}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             InputProps={{
//                                                 placeholder: "Enter state or province"
//                                             }}
//                                         />
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label>Postal Code (Optional)</label>
//                                         <TextField
//                                             fullWidth
//                                             name="zipCode"
//                                             value={formData.zipCode}
//                                             onChange={handleChange}
//                                             variant="outlined"
//                                             InputProps={{
//                                                 placeholder: "Enter postal code"
//                                             }}
//                                         />
//                                     </div>
//                                 </Grid>
//                                 <Grid item xs={12} md={6}>
//                                     <div className="form-field">
//                                         <label className="required">Country</label>
//                                         <FormControl variant="outlined" fullWidth required>
//                                             <Select
//                                                 name="country"
//                                                 value={formData.country}
//                                                 onChange={handleChange}
//                                                 displayEmpty
//                                             >
//                                                 <MenuItem value="">
//                                                     <em>--Select Country--</em>
//                                                 </MenuItem>
//                                                 <MenuItem value="UAE">United Arab Emirates</MenuItem>
//                                                 <MenuItem value="Saudi Arabia">Saudi Arabia</MenuItem>
//                                                 <MenuItem value="Qatar">Qatar</MenuItem>
//                                                 <MenuItem value="Oman">Oman</MenuItem>
//                                                 <MenuItem value="Kuwait">Kuwait</MenuItem>
//                                                 <MenuItem value="Bahrain">Bahrain</MenuItem>
//                                             </Select>
//                                         </FormControl>
//                                         {validator.message('country', formData.country, 'required')}
//                                     </div>
//                                 </Grid>
//                             </Grid>
//                         </div>
//                     </div>
//                 )}

//                 {step === 3 && (
//                     <div className="form-step">
//                         <div className="step-header">
//                             <div className="step-number">3</div>
//                             <h3>Required Documents</h3>
//                         </div>

//                         <div className="form-container">
//                             <div className="document-upload">
//                                 <div className="document-upload-item">
//                                     <label>Trade License <span className="required-field">*</span></label>
//                                     <p className="document-help">Upload your company's valid trade license</p>
//                                     <div className="upload-btn-wrapper">
//                                         <div className="upload-btn">
//                                             {formData.tradeLicense ? formData.tradeLicense.name : 'Choose file...'}
//                                         </div>
//                                         <input
//                                             type="file"
//                                             name="tradeLicense"
//                                             onChange={handleFileChange}
//                                             accept=".pdf,.jpg,.jpeg,.png"
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="document-upload-item">
//                                     <label>RERA Certificate <span className="required-field">*</span></label>
//                                     <p className="document-help">Upload your RERA (Real Estate Regulatory Authority) certificate</p>
//                                     <div className="upload-btn-wrapper">
//                                         <div className="upload-btn">
//                                             {formData.rera ? formData.rera.name : 'Choose file...'}
//                                         </div>
//                                         <input
//                                             type="file"
//                                             name="rera"
//                                             onChange={handleFileChange}
//                                             accept=".pdf,.jpg,.jpeg,.png"
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="document-upload-item">
//                                     <label>Tax Registration Certificate</label>
//                                     <p className="document-help">Upload your tax registration certificate (if applicable)</p>
//                                     <div className="upload-btn-wrapper">
//                                         <div className="upload-btn">
//                                             {formData.taxRegistration ? formData.taxRegistration.name : 'Choose file...'}
//                                         </div>
//                                         <input
//                                             type="file"
//                                             name="taxRegistration"
//                                             onChange={handleFileChange}
//                                             accept=".pdf,.jpg,.jpeg,.png"
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="document-upload-item">
//                                     <label>Passport Copy of Owner/GM <span className="required-field">*</span></label>
//                                     <p className="document-help">Upload passport copy of company owner or General Manager</p>
//                                     <div className="upload-btn-wrapper">
//                                         <div className="upload-btn">
//                                             {formData.passport ? formData.passport.name : 'Choose file...'}
//                                         </div>
//                                         <input
//                                             type="file"
//                                             name="passport"
//                                             onChange={handleFileChange}
//                                             accept=".pdf,.jpg,.jpeg,.png"
//                                         />
//                                     </div>
//                                 </div>

//                                 <div className="document-upload-item">
//                                     <label>Other Supporting Documents</label>
//                                     <p className="document-help">Upload any additional documents that support your application</p>
//                                     <div className="upload-btn-wrapper">
//                                         <div className="upload-btn">
//                                             {formData.otherDocuments ? formData.otherDocuments.name : 'Choose file...'}
//                                         </div>
//                                         <input
//                                             type="file"
//                                             name="otherDocuments"
//                                             onChange={handleFileChange}
//                                             accept=".pdf,.jpg,.jpeg,.png,.zip"
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 <div className="form-navigation">
//                     <Button
//                         className="cBtn cBtnLarge"
//                         onClick={handlePrevious}
//                     >
//                         <i className="fi ti-arrow-left"></i>
//                         Previous
//                     </Button>

//                     {step < 3 ? (
//                         <Button
//                             className="cBtn cBtnLarge cBtnTheme"
//                             onClick={handleNext}
//                         >
//                             Next Step
//                             <i className="fi ti-arrow-right"></i>
//                         </Button>
//                     ) : (
//                         <Button
//                             className="cBtn cBtnLarge cBtnTheme"
//                             type="submit"
//                         >
//                             <i className="fi flaticon-check"></i>
//                             Submit Registration
//                         </Button>
//                     )}
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default AgencyRegistrationForm;





























import React, { useState, useEffect } from 'react';
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import {
    sendBrokerRegistration,
    rateLimiter,
    handleApiError,
    getSuccessMessage
} from '../../utils/api';
import api from '../../api/axiosConfig';

const AgencyRegistrationForm = ({ onPrevious }) => {
    const [step, setStep] = useState(1);
    const [validator] = useState(new SimpleReactValidator({ className: 'error-message' }));
    const [headerData, setHeaderData] = useState({ heading: '', subheading: '' });
    const [isRegistering, setIsRegistering] = useState(false);
    const [formData, setFormData] = useState({
        companyName: '',
        email: '',
        relationshipManager: '',
        officeNumber: '',
        website: '',
        companyWhatsapp: '',
        gmWhatsapp: '',
        accountsContact: '',
        operationalCountry: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        country: '',
        tradeLicense: null,
        rera: null,
        taxRegistration: null,
        passport: null,
        otherDocuments: null
    });

    // Fetch dynamic header
    useEffect(() => {
        const fetchHeader = async () => {
            try {
                const res = await api.get('/BRegistration/br2');
                if (res.data && res.data.length > 0) {
                    setHeaderData({
                        heading: res.data[0].heading,
                        subheading: res.data[0].subheading
                    });
                }
            } catch (err) {
                console.error("Failed to fetch header data:", err);
            }
        };
        fetchHeader();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        validator.showMessages();
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData({ ...formData, [name]: files[0] });
    };

    const handleNext = () => {
        validator.showMessages();
        if (step === 1) {
            if (
                validator.fieldValid('companyName') &&
                validator.fieldValid('email') &&
                validator.fieldValid('officeNumber') &&
                validator.fieldValid('companyWhatsapp') &&
                validator.fieldValid('gmWhatsapp') &&
                validator.fieldValid('accountsContact') &&
                validator.fieldValid('operationalCountry')
            ) {
                setStep(2);
            } else {
                toast.error('Please fill all required fields!');
            }
        } else if (step === 2) {
            if (
                validator.fieldValid('address') &&
                validator.fieldValid('city') &&
                validator.fieldValid('country')
            ) {
                setStep(3);
            } else {
                toast.error('Please fill all required fields!');
            }
        }
    };

    const handlePrevious = () => {
        if (step > 1) setStep(step - 1);
        else onPrevious();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        validator.showMessages();
        if (!validator.allValid()) {
            toast.error('Please fill all required fields!');
            return;
        }
        if (!formData.tradeLicense || !formData.rera || !formData.passport) {
            toast.error('Please upload required documents (Trade License, RERA, Passport)');
            return;
        }
        // if (!rateLimiter.canMakeRequest('/api/send-broker-registration')) {
        //     toast.error('Too many requests. Please wait a moment.');
        //     return;
        // } NEED TO MODIFY IT!!!!!!!!!

        // Set loading state
        setIsRegistering(true);

        try {
            const apiFormData = new FormData();
            Object.keys(formData).forEach(key => {
                if (formData[key] !== null) {
                    apiFormData.append(key, formData[key]);
                }
            });
            // apiFormData.append('registrationType', 'agency');

            const response = await sendBrokerRegistration(formData);

            if (response.success) {
                toast.success(getSuccessMessage('broker'));
                // Reset form
                setFormData({
                    companyName: '',
                    email: '',
                    relationshipManager: '',
                    officeNumber: '',
                    website: '',
                    companyWhatsapp: '',
                    gmWhatsapp: '',
                    accountsContact: '',
                    operationalCountry: '',
                    address: '',
                    city: '',
                    state: '',
                    zipCode: '',
                    country: '',
                    tradeLicense: null,
                    rera: null,
                    taxRegistration: null,
                    passport: null,
                    otherDocuments: null
                });
                setStep(1);
            } else {
                throw new Error(response.message || 'Failed to submit registration');
            }
        } catch (error) {
            const errorMessage = handleApiError(error, 'broker');
            toast.error(errorMessage);
        } finally {
            // ALWAYS reset loading state in finally block
            setIsRegistering(false);
        }
    };

    return (
        <div className="agency-registration-form">
            <div className="form-header">
                <h2>{headerData.heading || "Agency Registration"}</h2>
                <p>{headerData.subheading || "Complete your agency profile to start accessing exclusive properties and client leads"}</p>
            </div>

            <form onSubmit={handleSubmit}>
                {step === 1 && (
                    <div className="form-step">
                        <div className="step-header">
                            <div className="step-number">1</div>
                            <h3>Company Information</h3>
                        </div>

                        <div className="form-container">
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <div className="form-field">
                                        <label className="required">Company Name</label>
                                        <TextField
                                            fullWidth
                                            name="companyName"
                                            value={formData.companyName}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            InputProps={{
                                                placeholder: "Enter your company name"
                                            }}
                                        />
                                        {validator.message('companyName', formData.companyName, 'required')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">Email Address</label>
                                        <TextField
                                            fullWidth
                                            name="email"
                                            type="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            InputProps={{
                                                placeholder: "your.email@example.com"
                                            }}
                                        />
                                        {validator.message('email', formData.email, 'required|email')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label>Relationship Manager</label>
                                        <FormControl variant="outlined" fullWidth>
                                            <Select
                                                name="relationshipManager"
                                                value={formData.relationshipManager}
                                                onChange={handleChange}
                                                displayEmpty
                                            >
                                                <MenuItem value="">
                                                    <em>--Select Relationship Manager--</em>
                                                </MenuItem>
                                                <MenuItem value="manager1">Nilum</MenuItem>
                                                <MenuItem value="manager2">Junaid</MenuItem>
                                                <MenuItem value="manager3">Jabbar Naveed</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">Office Phone Number</label>
                                        <TextField
                                            fullWidth
                                            name="officeNumber"
                                            value={formData.officeNumber}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            InputProps={{
                                                placeholder: "+971 XX XXX XXXX"
                                            }}
                                        />
                                        {validator.message('officeNumber', formData.officeNumber, 'required')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label>Website (Optional)</label>
                                        <TextField
                                            fullWidth
                                            name="website"
                                            value={formData.website}
                                            onChange={handleChange}
                                            variant="outlined"
                                            InputProps={{
                                                placeholder: "https://www.yourcompany.com"
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">Company WhatsApp</label>
                                        <TextField
                                            fullWidth
                                            name="companyWhatsapp"
                                            value={formData.companyWhatsapp}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            InputProps={{
                                                placeholder: "+971 XX XXX XXXX"
                                            }}
                                        />
                                        {validator.message('companyWhatsapp', formData.companyWhatsapp, 'required')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">General Manager WhatsApp</label>
                                        <TextField
                                            fullWidth
                                            name="gmWhatsapp"
                                            value={formData.gmWhatsapp}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            InputProps={{
                                                placeholder: "+971 XX XXX XXXX"
                                            }}
                                        />
                                        {validator.message('gmWhatsapp', formData.gmWhatsapp, 'required')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">Accounts Contact Number</label>
                                        <TextField
                                            fullWidth
                                            name="accountsContact"
                                            value={formData.accountsContact}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            InputProps={{
                                                placeholder: "+971 XX XXX XXXX"
                                            }}
                                        />
                                        {validator.message('accountsContact', formData.accountsContact, 'required')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">Operational Country</label>
                                        <FormControl variant="outlined" fullWidth required>
                                            <Select
                                                name="operationalCountry"
                                                value={formData.operationalCountry}
                                                onChange={handleChange}
                                                displayEmpty
                                            >
                                                <MenuItem value="">
                                                    <em>--Select Country--</em>
                                                </MenuItem>
                                                <MenuItem value="UAE">United Arab Emirates</MenuItem>
                                                <MenuItem value="Saudi Arabia">Saudi Arabia</MenuItem>
                                                <MenuItem value="Qatar">Qatar</MenuItem>
                                                <MenuItem value="Oman">Oman</MenuItem>
                                                <MenuItem value="Kuwait">Kuwait</MenuItem>
                                                <MenuItem value="Bahrain">Bahrain</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {validator.message('operationalCountry', formData.operationalCountry, 'required')}
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                )}

                {step === 2 && (
                    <div className="form-step">
                        <div className="step-header">
                            <div className="step-number">2</div>
                            <h3>Address Information</h3>
                        </div>

                        <div className="form-container">
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <div className="form-field">
                                        <label className="required">Complete Address</label>
                                        <TextField
                                            fullWidth
                                            name="address"
                                            value={formData.address}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            multiline
                                            rows={3}
                                            InputProps={{
                                                placeholder: "Enter your complete business address"
                                            }}
                                        />
                                        {validator.message('address', formData.address, 'required')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">City</label>
                                        <TextField
                                            fullWidth
                                            name="city"
                                            value={formData.city}
                                            onChange={handleChange}
                                            variant="outlined"
                                            required
                                            InputProps={{
                                                placeholder: "Enter city name"
                                            }}
                                        />
                                        {validator.message('city', formData.city, 'required')}
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label>State/Province (Optional)</label>
                                        <TextField
                                            fullWidth
                                            name="state"
                                            value={formData.state}
                                            onChange={handleChange}
                                            variant="outlined"
                                            InputProps={{
                                                placeholder: "Enter state or province"
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label>Postal Code (Optional)</label>
                                        <TextField
                                            fullWidth
                                            name="zipCode"
                                            value={formData.zipCode}
                                            onChange={handleChange}
                                            variant="outlined"
                                            InputProps={{
                                                placeholder: "Enter postal code"
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="form-field">
                                        <label className="required">Country</label>
                                        <FormControl variant="outlined" fullWidth required>
                                            <Select
                                                name="country"
                                                value={formData.country}
                                                onChange={handleChange}
                                                displayEmpty
                                            >
                                                <MenuItem value="">
                                                    <em>--Select Country--</em>
                                                </MenuItem>
                                                <MenuItem value="UAE">United Arab Emirates</MenuItem>
                                                <MenuItem value="Saudi Arabia">Saudi Arabia</MenuItem>
                                                <MenuItem value="Qatar">Qatar</MenuItem>
                                                <MenuItem value="Oman">Oman</MenuItem>
                                                <MenuItem value="Kuwait">Kuwait</MenuItem>
                                                <MenuItem value="Bahrain">Bahrain</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {validator.message('country', formData.country, 'required')}
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                )}

                {step === 3 && (
                    <div className="form-step">
                        <div className="step-header">
                            <div className="step-number">3</div>
                            <h3>Required Documents</h3>
                        </div>

                        <div className="form-container">
                            <div className="document-upload">
                                <div className="document-upload-item">
                                    <label>Trade License <span className="required-field">*</span></label>
                                    <p className="document-help">Upload your company's valid trade license</p>
                                    <div className="upload-btn-wrapper">
                                        <div className="upload-btn">
                                            {formData.tradeLicense ? formData.tradeLicense.name : 'Choose file...'}
                                        </div>
                                        <input
                                            type="file"
                                            name="tradeLicense"
                                            onChange={handleFileChange}
                                            accept=".pdf,.jpg,.jpeg,.png"
                                        />
                                    </div>
                                </div>

                                <div className="document-upload-item">
                                    <label>RERA Certificate <span className="required-field">*</span></label>
                                    <p className="document-help">Upload your RERA (Real Estate Regulatory Authority) certificate</p>
                                    <div className="upload-btn-wrapper">
                                        <div className="upload-btn">
                                            {formData.rera ? formData.rera.name : 'Choose file...'}
                                        </div>
                                        <input
                                            type="file"
                                            name="rera"
                                            onChange={handleFileChange}
                                            accept=".pdf,.jpg,.jpeg,.png"
                                        />
                                    </div>
                                </div>

                                <div className="document-upload-item">
                                    <label>Tax Registration Certificate</label>
                                    <p className="document-help">Upload your tax registration certificate (if applicable)</p>
                                    <div className="upload-btn-wrapper">
                                        <div className="upload-btn">
                                            {formData.taxRegistration ? formData.taxRegistration.name : 'Choose file...'}
                                        </div>
                                        <input
                                            type="file"
                                            name="taxRegistration"
                                            onChange={handleFileChange}
                                            accept=".pdf,.jpg,.jpeg,.png"
                                        />
                                    </div>
                                </div>

                                <div className="document-upload-item">
                                    <label>Passport Copy of Owner/GM <span className="required-field">*</span></label>
                                    <p className="document-help">Upload passport copy of company owner or General Manager</p>
                                    <div className="upload-btn-wrapper">
                                        <div className="upload-btn">
                                            {formData.passport ? formData.passport.name : 'Choose file...'}
                                        </div>
                                        <input
                                            type="file"
                                            name="passport"
                                            onChange={handleFileChange}
                                            accept=".pdf,.jpg,.jpeg,.png"
                                        />
                                    </div>
                                </div>

                                <div className="document-upload-item">
                                    <label>Other Supporting Documents</label>
                                    <p className="document-help">Upload any additional documents that support your application</p>
                                    <div className="upload-btn-wrapper">
                                        <div className="upload-btn">
                                            {formData.otherDocuments ? formData.otherDocuments.name : 'Choose file...'}
                                        </div>
                                        <input
                                            type="file"
                                            name="otherDocuments"
                                            onChange={handleFileChange}
                                            accept=".pdf,.jpg,.jpeg,.png,.zip"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="form-navigation">
                    <Button
                        className="cBtn cBtnLarge"
                        type="button"
                        onClick={handlePrevious}
                    >
                        <i className="fi ti-arrow-left"></i>
                        Previous
                    </Button>

                    {step < 3 ? (
                        <Button
                            className="cBtn cBtnLarge cBtnTheme"
                            type="button"
                            onClick={handleNext}
                        >
                            Next Step
                            <i className="fi ti-arrow-right"></i>
                        </Button>
                    ) : (
                        <Button
                            className="cBtn cBtnLarge cBtnTheme"
                            type="submit"
                            disabled={isRegistering}
                        >
                            <i className="fi flaticon-check"></i>
                            {isRegistering ? "Submitting..." : "Submit Registration"}
                        </Button>
                    )}
                </div>
            </form>
        </div>
    );
};

export default AgencyRegistrationForm;
